import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonRange } from '@ionic/angular/standalone';

import { CurrencyCustomPipe } from '../../../pipes';

@Component({
    selector: 'lib-range',
    imports: [CommonModule, IonRange, FormsModule, CurrencyCustomPipe],
    templateUrl: './range.component.html',
    styleUrl: './range.component.css'
})
export class RangeComponent {
    /* eslint-disable */
    @Input() value: number | null = 0;
    @Input() valueDual: { lower: number; upper: number } | null = { lower: 0, upper: 0 };
    @Input() step: number = 5;
    @Input() min: number = 0;
    @Input() max: number = 100;

    @Input() title: string = '';
    @Input() label: string = '';
    @Input() unit: string = '';
    @Input() unitPlural: string = '';

    @Input() labelAsTitle: boolean = false;
    @Input() displayPlusForMax: boolean = false;

    /** Displays the value as a dollar value */
    unitAsDollarValue = input<boolean>(false);

    /** Toggles showing two knobs or one */
    dualKnobs = input<boolean>(false);

    @Output() onRangeChange = new EventEmitter();

    onRangeInput(event: CustomEvent) {
        if (this.dualKnobs()) {
            this.valueDual = event.detail.value;
        } else {
            this.value = event.detail.value;
        }
    }

    rangeChange(event: CustomEvent) {
        console.log(event.detail.value);

        this.onRangeChange.emit(event.detail.value);
    }
}
